import * as XLSX from "xlsx"
import moment from "moment"
import { auth, db } from "../../../utils/firebase"

const exportToExcel = async (rows, fileName, { periodLabel } = {}) => {
	// Sort rows by agent name then booked date
	const sorted = [...rows].sort((a, b) => {
		const n = a.agent_name.localeCompare(b.agent_name)
		if (n !== 0) return n
		return a.booked_ms - b.booked_ms
	})

	// Per-agent totals
	const totalsByAgent = {}
	let grandTotal = 0
	sorted.forEach((row) => {
		if (!totalsByAgent[row.agent_id]) {
			totalsByAgent[row.agent_id] = { name: row.agent_name, total: 0, count: 0 }
		}
		totalsByAgent[row.agent_id].total += row.this_payment
		totalsByAgent[row.agent_id].count += 1
		grandTotal += row.this_payment
	})

	// Generated-by user
	const currentUserDoc = await db.doc(`users/${auth.currentUser.uid}`).get()
	const currentUserData = currentUserDoc.data()
	const generatedBy = currentUserData?.first_name && currentUserData?.last_name ? `${currentUserData.first_name} ${currentUserData.last_name}` : "Unknown"

	const sheet = [
		["Commission Report (Banded — itemised)"],
		[],
		["Period:", periodLabel || ""],
		["Generated by:", generatedBy],
		["Generated on:", moment().format("DD/MM/YYYY HH:mm:ss")],
		["Bookings:", sorted.length],
		["Total to pay this run:", grandTotal.toFixed(2)],
		[],
		["Per-agent totals"],
		["Agent", "Bookings", "Total this run"],
	]

	Object.values(totalsByAgent)
		.sort((a, b) => a.name.localeCompare(b.name))
		.forEach((a) => {
			sheet.push([a.name, a.count, a.total.toFixed(2)])
		})

	sheet.push([])
	sheet.push(["Itemised bookings"])
	sheet.push([
		"Agent",
		"Booking ref",
		"Booked date",
		"Booked month",
		"Travel date",
		"Booking margin (£)",
		"Agent margin in booked month (£)",
		"Target (booked month, £)",
		"% to target",
		"Band",
		"Full commission (£)",
		"Commission paid so far (£)",
		"Payment",
		"This payment (£)",
	])

	sorted.forEach((row) => {
		sheet.push([
			row.agent_name,
			row.reference,
			moment(row.booked_ms).format("DD/MM/YYYY"),
			row.booked_month_label,
			moment(row.travel_ms).format("DD/MM/YYYY"),
			row.profit.toFixed(2),
			row.is_legacy ? "" : row.agent_monthly_margin.toFixed(2),
			row.is_legacy ? "" : row.has_target ? row.target.toFixed(2) : "",
			row.is_legacy || !row.has_target ? "—" : `${row.percent_to_target.toFixed(2)}%`,
			row.band_label,
			row.full_commission.toFixed(2),
			(row.commission_paid_so_far || 0).toFixed(2),
			row.payment_label,
			row.this_payment.toFixed(2),
		])
	})

	const worksheet = XLSX.utils.aoa_to_sheet(sheet)
	worksheet["!cols"] = [
		{ wch: 26 },
		{ wch: 18 },
		{ wch: 14 },
		{ wch: 14 },
		{ wch: 14 },
		{ wch: 18 },
		{ wch: 28 },
		{ wch: 22 },
		{ wch: 14 },
		{ wch: 10 },
		{ wch: 20 },
		{ wch: 22 },
		{ wch: 14 },
		{ wch: 18 },
	]

	const workbook = XLSX.utils.book_new()
	XLSX.utils.book_append_sheet(workbook, worksheet, "Commission Report")

	const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "binary" })
	const blob = new Blob([s2ab(wbout)], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })

	const url = window.URL.createObjectURL(blob)
	const link = document.createElement("a")
	link.href = url
	link.download = `${fileName}.xlsx`
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
	window.URL.revokeObjectURL(url)

	return blob
}

function s2ab(s) {
	const buf = new ArrayBuffer(s.length)
	const view = new Uint8Array(buf)
	for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff
	return buf
}

export default exportToExcel
